import * as types from '../actionTypes/app'
import * as authTypes from '../actionTypes/auth'

let defaultState = {
  isLoading: false,
  errorCount: 0,
  ajaxResponse: {},
  isMenuOpen: false
}

const appReducer = (state = defaultState, action) => {
  if (action.type === types.SET_LOADING_STATUS) {
    return {
      ...state,
      isLoading: action.isLoading
    }
  }
  else if (action.type === types.INCREMENT_ERROR_COUNT) {
    return {
      ...state,
      errorCount: state.errorCount + 1
    }
  }
  else if (action.type === types.CLEAR_ERROR_COUNT) {
    return {
      ...state,
      errorCount: 0
    }
  }
  else if (action.type === types.SET_AJAX_RESPONSE) {
    return {
      ...state,
      ajaxResponse: action.ajaxResponse
    }
  }
  else if (action.type === authTypes.SESSION_TIMED_OUT) {
    return {
      ...state,
      ajaxResponse: action.message
    }
  }
  else if (action.type === types.CLEAR_AJAX_RESPONSE) {
    return {
      ...state,
      ajaxResponse: {}
    }
  }
  else if (action.type === types.TOGGLE_MENU) {
    return {
      ...state,
      isMenuOpen: !state.isMenuOpen
    }
  }
  else {
    return {
      ...state
    }
  }
}

export default appReducer;


// WEBPACK FOOTER //
// ./src/reducers/app.js